<template>
  <base-modal
    size="md"
    show
    has-close-btn
    warning
    :heading="$t('marketplace.cancel_transaction')"
    @close:modal="() => $emit('close:modal')"
  >
    {{ $t('marketplace.cancel_transaction_text') }}
    <template #footer>
      <base-button warning @click="$emit('confirm')">
        {{ $t('confirm') }}
      </base-button>
    </template>
  </base-modal>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close:modal', 'confirm'],
}
</script>
